import Aos from "aos";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSingle from "../Services/Card/CardSingle";
import img1 from "../../assets/img/serviceinsidepics/train1.jpg";
import img2 from "../../assets/img/serviceinsidepics/bns2.png";
import img3 from "../../assets/img/serviceinsidepics/train3.jpg";
import TextSingle from "../Services/TextCard/TextSingle";
import LifeSpan from "../Services/lifeSpan-Contact/Lifespan";
import NormalText from "../Services/NormalText/NormalText";
import { useAllPrismicDocumentsByType } from "@prismicio/react";

const items = [
  {
    src: "/train1.jpg",
    title: "Oracle Cloud Assessment",
    subtitle:
      "Oracle Cloud Assessment which is designed to help organizations prepare a business case and help develop a cloud adoption roadmap.",
    dataaos: "zoom-out-right",
  },
  {
    src: "/bns1.png",
    title: "Implementations and Roll Outs",
    subtitle:
      "The Oracle Cloud Fixed Scope Offering (FSO) from Technologies is designed by incorporating leading practices to provide a Fast Track",
  },
  {
    src: "/train3.jpg",
    title: "Oracle Sales Cloud",
    subtitle:
      "Today’s selling organizations face unprecedented competition.customer relationship management solution that offers capabilities and features enabling companies to significantly grow through accelerated sales, improved customer engagement.",
    dataaos: "zoom-out-left",
  },
];
const texts = [
  {
    dataaos: "fade-right",
    title: "Establish open communication",
    subtitle:
      "where you voice concerns to the service provider through healthy and transparent dialog by involving appropriate stakeholders from both sides on equal conditions with a transparent relation between cost and pricing, to get access to and share communication resources on one level to provide value added services on another level in a layered communication",
  },
  {
    title: "Realign priorities to reset relationship",
    subtitle:
      "where you create a plan that identifies milestones and check points, and articulates what success looks likethe flow of information between people, is a very important part of the workplace. Managers must be able to communicate with employees and employees must be able to communicate with managers in order to have a profitable business.",
  },
  {
    dataaos: "fade-left",
    title: "Stability of Core Systems",
    subtitle:
      "To build resilience and adaptability in enterprises.Repeating the obvious - repeating orders is common, but it is never more important than in a code situation.",
  },
];

const Outsource = (props: any) => {
  const [document] = useAllPrismicDocumentsByType("outsourcingpartner");

  const slice3 = document && document[0]?.data;

  const bg = {
    backgroundImage: `url(${
      slice3 ? slice3?.body[0].primary.bg_img.url : "/Outsource.jpg"
    })`,
    backgroundSize: "cover",
    backgroundPosition: "right",

    backgroundRepeat: " no-repeat",
  };
  const Textbg = {
    backgroundImage: `url(${
      slice3 ? slice3?.body[2].primary.bgimg.url : "/outpartner2.gif"
    })`,
    backgroundSize: "cover",
    backgroundPosition: "center",

    backgroundRepeat: " no-repeat",
  };
  const NormalTextbg = {
    backgroundImage: `url(${
      slice3 ? slice3?.body[3].primary.bgimg2.url : "/Outsource3.jfif"
    })`,
    backgroundSize: "cover",
    backgroundPosition: "center",

    backgroundRepeat: " no-repeat",
  };

  useEffect(() => {
    Aos.init();
    window.scrollTo(0, 0);
  }, []);

  const NormalCardData = items.map((item: any, i: any) => {
    return (
      <div
        className="col-lg-4 col-md-6 md-mb--40"
        data-aos={item.dataaos}
        data-aos-duration="1500"
        key={i}
      >
        <CardSingle
          itemClass="courses-item"
          image={item.src}
          title={item.title}
          subtitle={item.subtitle}
        />
      </div>
    );
  });

  const PrismicCardData = slice3?.body[1]?.items?.map((item: any, i: any) => {
    return (
      <div
        className="col-lg-4 col-md-6 md-mb--40"
        data-aos={item.tittle3[0].text}
        data-aos-duration="1500"
        key={i}
      >
        <CardSingle
          itemClass="courses-item"
          image={item.cardimage.url}
          title={item.tittle1[0].text}
          subtitle={item.tittle2[0].text}
        />
      </div>
    );
  });

  const NormalTextData = texts.map((item: any, i: any) => {
    return (
      <div
        className="col-lg-4 col-md-6 mb-30"
        data-aos={item.dataaos}
        data-aos-duration="1500"
      >
        <TextSingle
          itemClass="courses-item"
          title={item.title}
          subtitle={item.subtitle}
        />
      </div>
    );
  });

  const PrismicTextData = slice3?.body[2]?.items?.map((item: any, i: any) => {
    return (
      <div className="col-lg-4 col-md-6 mb-30" data-aos-duration="1500">
        <TextSingle
          itemClass="courses-item"
          title={item.tittle1[0].text}
          subtitle={item.tittle2[0].text}
        />
      </div>
    );
  });

  return (
    <React.Fragment>
      <div className="webportal main-home  mt-130 md-mt-60" style={bg}>
        <div className="partition-bg-wrap">
          <div className="container">
            <div className="row">
              <div className=" col-lg-6 md-pl-14 pt-30">
                <div className="sec-title3 mb-40">
                  <h2
                    className="title white-color mb-16 Heading"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1800"
                    style={{ fontSize: "40px" }}
                  >
                    {slice3
                      ? slice3?.body[0].primary.tittle[0].text
                      : "Outsourcing Partners"}
                  </h2>
                  <p
                    className="desc white-color  md-pr-0 sub-text"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="3000"
                    style={{
                      fontSize: "15px",
                      lineHeight: " 1.4",
                      textAlign: "justify",
                    }}
                  >
                    {slice3
                      ? slice3?.body[0].primary.text1[0].text
                      : "All you need to do is let us know what your overall objectives are for your business. We then get back to you with a comprehensive plan that details our specific recommendations and a proposal to assist in enhancing your business."}
                    <br /> <br />{" "}
                    {slice3
                      ? slice3?.body[0].primary.text2[0].text
                      : "Businesses are required to focus their attention and time on vital activities, including generating new business. Allow us the ability to oversee complete development until the end. You have many things to worry about, let outsourcing partners take care of Outsourcing Companies."}
                    <br /> <br />
                    {slice3
                      ? slice3?.body[0].primary.text3[0].text
                      : "The different kinds of customers that they have provided in delivering the required services at the scale of your business needs. This can help you analyze if the particula outsourcing service provider is best suited for yourbusiness."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="card-ss main-home event-bg pt-50 pb-10 md-pt-30 md-pb-0"
        style={{ background: "#00758F" }}
      >
        <div className="container">
          <div className="row">{slice3 ? PrismicCardData : NormalCardData}</div>
        </div>
      </div>

      <div
        className="card-Text main-home event-bg pt-10 pb-40 md-pt-10 md-pb-20 mbl-mb--100"
        style={Textbg}
      >
        <div className="container">
          <div className="row">{slice3 ? PrismicTextData : NormalTextData}</div>
        </div>
      </div>

      <div
        className="noraml-Text main-home event-bg pt-30 pb-40 md-pt-10 md-pb-190"
        style={NormalTextbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-11 col-md-6 mb-100"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <NormalText
                itemClass="courses-item"
                title={
                  slice3
                    ? slice3?.body[3].primary.tittle[0].text
                    : "Value Proposition"
                }
                listClass="display-none"
                portalList="portal-none"
                cloudList="cloud-none"
                ecommerce="ecommerce-none"
                listtwo="listtwo-none"
                listthree="listthree-none"
                subtitle1={
                  slice3
                    ? slice3?.body[3].primary.text1[0].text
                    : "Where you evaluate and implement appropriate changes in behavior of internal organization that fosters a partnership environment."
                }
                subtitle2={
                  slice3
                    ? slice3?.body[3].primary.text2[0].text
                    : "Is a promise of value to be delivered, communicated, and acknowledged. It is also a belief from the customer about how value (benefit) will be delivered, experienced and acquired. ... Creating a value proposition is a part of business strategy."
                }
                subtitle3={
                  slice3
                    ? slice3?.body[3].primary.text3[0].text
                    : "Executives set value propositions for their products — the target market segments, the benefits they provide, and their prices. It's why a target customer should buy the product. But value propositions go beyond just products. Your personal value proposition (PVP) is at the heart of your career strategy."
                }
              />
            </div>
          </div>
        </div>
      </div>
      <LifeSpan />
    </React.Fragment>
  );
};

export default Outsource;
